import React from 'react';

import useAppContext from 'flow/hooks/useAppContext';
import EmptyBubble from '../empty-states/EmptyBubble';

/** Stands in for the list while this user has no chats at all. */
const NoChatSessions = () => {
    const { i18next } = useAppContext();

    return (
        <EmptyBubble
            title={i18next.t('EmptyState.ChatList.Title')}
            message={i18next.t('EmptyState.ChatList.Message1')}
            imageId={'message'}
        />
    );
};

export default React.memo(NoChatSessions);
